import React from 'react';
import './Hero.css';

function Hero() {
  const heroBgStyle = {
    backgroundImage: `url(/assets/NeXusNeuroHero.webp)`,
  };

  return (
    <section className="nn-hero">
      <div className="nn-hero-bg" style={heroBgStyle} />
      <div className="nn-hero-frame reveal">
        <img
          src="/assets/nexus_neuro_logo.webp"
          alt="NeXus NeuroInformatics, Inc."
          className="nn-hero-wordmark"
        />
        <span className="nn-hero-label">Biology-Native AI · Physiological Digital Twins</span>
        <h1 className="nn-hero-title">
          Build the biology.<br />
          Preserve the state.<br />
          <span className="iso-gold">Test the world.</span>
        </h1>
        <p className="nn-hero-deck">
          Governed, calculation-grounded physiological digital twins—built on <strong>AetherProtocols</strong>, executed through <strong>Scyla</strong>, and explored through <strong>AETHER</strong>.
        </p>
        <div className="nn-hero-pills">
          <span className="nn-pill">Longitudinal State</span>
          <span className="nn-pill">Executable Biology</span>
          <span className="nn-pill-break" aria-hidden="true"></span>
          <span className="nn-pill">Synthetic Biological Worlds</span>
          <span className="nn-pill-break" aria-hidden="true"></span>
          <span className="nn-pill">Evidence · Provenance · Abstention</span>
        </div>
        <p className="nn-hero-boundary">Research-stage technology. Not a diagnostic system or representation of completed clinical validation.</p>
      </div>
    </section>
  );
}

export default Hero;
